import React from 'react';
import styled from 'styled-components';


const FooterWrapper = styled.div`
    width: 100%;
    background-color: white;
    color: black;
    & > * {
        padding: 12px 12px 12px 12px;
        margin: auto;
        display: block;
    }
`;

const FooterTitle = styled.p`
    font-weight: bold;
`;

const Logo = styled.img`
    margin: 10px 10px 10px 10x;
    border-radius: 50%;
    width: 150px;
    height: 150px;
`;

const Button = styled.button`
    display: inline-block;
    margin: 0 10px 20px; 
    color: #1E88E5;
    background-color: transparent;
    border: 2px solid #1E88E5;
    border-radius: 4px;
    text-transform: uppercase;
    font-size: 1em;
    font-weight: 500;
    text-decoration: none;
    padding: 0.5em 2em;
    position: relative;
    overflow: hidden; 
`;

export default function BusinessCardFooter({title,buttonText,link}){

    return(
        <FooterWrapper>
            <FooterTitle>{title}</FooterTitle>
            <Logo src={'/images/smartcardlogo.jpg'} />
            <a href={link}>
                <Button>{buttonText}</Button>
            </a>
        </FooterWrapper>
    )

}